import React, {useState} from "react";
import {formatDate, getNumberWithOrdinal} from "../../../util";
import Info from "./Info";

const STATUS_UNDER_REVIEW = 3;
const STATUS_REQUIRED_REVIEWS_COMPLETE = 4;
const STATUS_REVIEWER_INVITED = 23;

const statusMap = new Map<number, string>()
statusMap.set(STATUS_UNDER_REVIEW, "Under Review");
statusMap.set(STATUS_REQUIRED_REVIEWS_COMPLETE, "Required Reviews Complete")
statusMap.set(STATUS_REVIEWER_INVITED, "Under Review")
const aboutRequiredReviewCompleted = {
    header: 'Required Reviews Complete',
    body: `After the target number of reviews has been completed, the Handling Editor considers the 
           reviews. The Editor may invite more reviewers, returning the submission to 'Under Review'
           status, or may begin to enter a decision.`
}
const aboutLastReviewActivity = {
    header: 'Last review activity',
    body: `This shows the last time a reviewer was invited, 
           accepted, or completed their review. This will differ from the Status Date shown in Editorial Manager.`
}

type StatusBoxProps = {
    status?: number;
    lastUpdated?: number;
    revision?: any;
}

const StatusBox = ({status = STATUS_UNDER_REVIEW, lastUpdated, revision}: StatusBoxProps) => {
    const statusText = statusMap.has(status) ? statusMap.get(status) : "Review Complete"
    const [infoRequiredReviewsCompletedClicked, setInfoRequiredReviewsCompletedClicked] = useState<boolean>(false);
    const [infoLastReviewActivityClicked, setInfoLastReviewActivityClicked] = useState<boolean>(false);

    const handleRequiredReviewsCompletedInfoClick = () => {
        setInfoRequiredReviewsCompletedClicked(true);
        setInfoLastReviewActivityClicked(false);
    }

    const handleLastReviewActivityInfoClick = () => {
        setInfoLastReviewActivityClicked(true);
        setInfoRequiredReviewsCompletedClicked(false);
    }

    const handleRequiredReviewsCompletedPopupClose = () => {
        setInfoRequiredReviewsCompletedClicked(false);
    }

    const handleLastReviewActivityPopupClose = () => {
        setInfoLastReviewActivityClicked(false);
    }

    return (
        <>
            <div className="statusbox">
                <h2 className="visible-only-to-screen-reader">Submission status and date</h2>
                {revision > 0 && (
                    <div className="lastupdate">
                        {getNumberWithOrdinal(revision)} revision
                    </div>
                )}
                <div className="statusstate">
                    <div style={{display:"inline"}}>{statusText}</div>
                    {
                        status === STATUS_REQUIRED_REVIEWS_COMPLETE &&
                        <Info isOpen={infoRequiredReviewsCompletedClicked}
                              id={"reqRevCompleted"}
                              details={aboutRequiredReviewCompleted}
                              handleOpen={handleRequiredReviewsCompletedInfoClick}
                              handleClose={handleRequiredReviewsCompletedPopupClose}
                        />
                    }
                </div>

                {lastUpdated && (
                    <div className="lastdate">
                        <div style={{display:"inline"}}>Last review activity: {formatDate(lastUpdated)}</div>
                        <Info isOpen={infoLastReviewActivityClicked}
                              id={"reviewActivity"}
                              details={aboutLastReviewActivity}
                              handleOpen={handleLastReviewActivityInfoClick}
                              handleClose={handleLastReviewActivityPopupClose}
                              position={{top: -3}}
                        />
                    </div>
                )}
            </div>
        </>
    );
};

export default StatusBox;
